import React from 'react';
import { useTranslation } from 'react-i18next';
import { IKnownFrom } from '@lialo/core/lib/models';
import { Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ExternalLink } from '@lialo/pwa-ui/lib/ExternalLink';

const StyledLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',

  '& > img': {
    marginRight: theme.spacing(1),
  },
})) as typeof Link;

const UnstyledList = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,

  '& li': {
    paddingBottom: theme.spacing(1),
  },
}));

const Headline = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  paddingBottom: theme.spacing(1),
}));

interface Props {
  knownFrom: IKnownFrom[];
}

export const KnownFrom = ({ knownFrom }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Headline variant={'subtitle2'}>{t('tour_detail.known_from')}</Headline>

      <UnstyledList>
        {knownFrom.map(({ url, favicon, text }) => (
          <li key={text}>
            <StyledLink component={ExternalLink} href={url}>
              <img src={favicon} alt={''} />
              {text}
            </StyledLink>
          </li>
        ))}
      </UnstyledList>
    </>
  );
};
